import {useMemo} from 'react';
import {debounce} from 'lodash';

export const useDebounce = <T extends (...args: any[]) => void>(fn: T, delayMs: number) => {
    return useMemo(() => {
        return debounce(fn, delayMs);
    }, [delayMs, fn]);
};